export const PROVIDER = 'provider';
export const PUBLISHER = 'publisher';
export const SECRET_KEY = process.env.REACT_APP_FMS_API_SECRET || 'VL80aSqvuVcXJA4jcp7psx0TxmMFInf9';
